<template>
  <div
    v-if="props.artists?.length"
    class="md:flex items-start artist-info"
  >
    <div
      class="artist-links"
    >
      <template
        v-for="artist in props.artists"
      >
        <div
          class="artist-name"
        >
          {{ artist.name }}
        </div>
        <div class="artist-social-links">
          <a
            v-for="link in links(artist)"
            :key="link.brand"
            :href="link.url"
            :title="link.brand"
            target="_blank"
            class="artist-link"
          >
            <img
              v-if="link.icon"
              :src="`https://cdn.jsdelivr.net/npm/simple-icons@v14/icons/${link.icon}.svg`"
              :alt="$gettext('Artist %{page}', { page: link.brand })"
            >
            <iconify-icon
              v-else
              icon="mdi:web"
              class="flex"
              :alt="$gettext('Artist page')"
            />
          </a>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Checkout, Util } from '@vp/common';

type Props = {
  artists: Checkout.CheckoutArtist.CheckoutArtist[];
};

const props = defineProps<Props>();

type Brand = {
  brand: string;
  icon?: string;
};

const brands: Record<string, Brand> = {
  applemusic: {
    brand: 'Apple Music',
    icon: 'applemusic',
  },
  bandcamp: {
    brand: 'Bandcamp',
    icon: 'bandcamp',
  },
  facebook: {
    brand: 'Facebook',
    icon: 'facebook',
  },
  instagram: {
    brand: 'Instagram',
    icon: 'instagram',
  },
  lastfm: {
    brand: 'Last.fm',
    icon: 'lastdotfm',
  },
  songkick: {
    brand: 'Songkick',
    icon: 'songkick',
  },
  soundcloud: {
    brand: 'SoundCloud',
    icon: 'soundcloud',
  },
  spotify: {
    brand: 'Spotify',
    icon: 'spotify',
  },
  tiktok: {
    brand: 'TikTok',
    icon: 'tiktok',
  },
  x: {
    brand: 'X',
    icon: 'x',
  },
  website: {
    brand: 'Website',
  },
  wikipedia: {
    brand: 'Wikipedia',
    icon: 'wikipedia',
  },
  youtube: {
    brand: 'YouTube',
    icon: 'youtube',
  },
};

const links = (artist: Checkout.CheckoutArtist.CheckoutArtist) => {
  return Util.normalizeArtistLinks(artist.links || [])
    .filter(({ url }) => url)
    .map(({ url, _type }) => {
      const cleanUrl = url.replace(/^(https?:\/\/)?/, 'https://');
      const brand = brands[_type];

      return {
        url: cleanUrl,
        brand: brand?.brand ?? null,
        icon: brand?.icon ?? null,
      };
    });
};
</script>
